import { ValueType } from 'realgrid'

export const imposeFields = [
    {
      fieldName: 'deptCd',
      dataType: ValueType.TEXT
    },
    {
      fieldName: 'deptNm',
      dataType: ValueType.TEXT
    }
  ]
  
  export const imposeColumns = [
    {
      name: 'deptCd',
      fieldName: 'deptCd',
      type: 'data',
      width: '100',
      styleName: "rg-align-center",
      header: {
        text: '부과코드',
        showTooltip: false
      },
      visible: true,
      editable: false
    },
    {
      name: 'deptNm',
      fieldName: 'deptNm',
      type: 'data',
      width: '200',
      styleName: "rg-align-left",
      header: '부과명',
      visible: true,
      editable: false
    }
  ]